import { Component, ViewChild, ElementRef, ChangeDetectionStrategy} from '@angular/core';
import { AgFrameworkComponent } from 'ag-grid-angular';
import { IFloatingFilter, IFloatingFilterParams } from 'ag-grid-enterprise';

export interface CustomHeaderParams extends IFloatingFilterParams {
    value: number;
    maxValue: number;
}
@Component({ standalone: false,
    selector: 'dux-app-loading-overlay',
    template: `
        @if (headerCheckBox) {
          <div
            class="ag-header-select-all ag-labeled ag-label-align-right ag-checkbox"
            role="presentation"
            ref="cbSelectAll" >
            <label ref="eLabel" class="ag-hidden"></label>
            <div (click)="cbSelectAll()" (keydown.space)="cbSelectAll(); $event.preventDefault()" ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation" tabindex="0">
              <input ref="eInput" #cbSelectAllInp type="checkbox" checked="{{cbSelectAllInpChecked}}" class="ag-hidden">
              <div>
                <span class="ag-selection-checkbox" unselectable="on">
                  <img height="17px" width="17px" src="../../assets/images/checkboxChecked.svg"
                    [class]="{'ag-hidden': params.parentObject?.headerCheckBoxState!=='checked'}">
                  <img height="17px" width="17px" src="../../assets/images/checkboxUnchecked.svg"
                    [class]="{'ag-hidden': params.parentObject?.headerCheckBoxState!=='unchecked'}">
                  <img height="17px" width="17px" src="../../assets/images/checkboxIndeterminate.svg"
                    [class]="{'ag-hidden': params.parentObject?.headerCheckBoxState!=='indeterminate'}">
                </span>
              </div>
            </div>
          </div>
        }
        @if (rowCheckBox) {
          <div
            class="ag-header-select-all ag-labeled ag-label-align-right ag-checkbox"
            role="presentation"
            ref="cbSelectAll">
            <label ref="eLabel" class="ag-hidden"></label>
            @if (!isDisabled()) {
              <div (click)="rowSelectedAction(params, $event)" (keydown.space)="rowSelectedAction(params, $event); $event.preventDefault()" ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation" tabindex="0">
                <span class="ag-selection-checkbox" unselectable="on">
                  <img height="17px" width="17px" src="../../assets/images/checkboxChecked.svg"
                    [class]="{'ag-hidden': !params.node.isSelected()}">
                  <img height="17px" width="17px" src="../../assets/images/checkboxUnchecked.svg"
                    [class]="{'ag-hidden': params.node.isSelected()}">
                </span>
              </div>
            }
            @if (isDisabled()) {
              <div ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation">
                <span class="ag-selection-checkbox" unselectable="on">
                  <img height="17px" width="17px" class="ag-disabled-img" src="../../assets/images/checkboxChecked.svg"
                    [class]="{'ag-hidden': !params.node.isSelected()}">
                  <img height="17px" width="17px" class="ag-disabled-img" src="../../assets/images/checkboxUnchecked.svg"
                    [class]="{'ag-hidden': params.node.isSelected()}">
                </span>
              </div>
            }
          </div>
        }
        @if (clearAllBtn) {
          <div>
            <div class="btn-action-clear-filter" title="Clear all filters" (click)="clearAllFilters()"></div>
          </div>
        }`,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class IrbCustomHeaderComponent implements IFloatingFilter, AgFrameworkComponent<IFloatingFilterParams> {
    private static _lastSelectedIndex: number;
    params: any;
    checkedValue = false;
    checkedStyleClass = 'unchecked'; // indeterminate, checked, unchecked
    checkedRowStyleClass = 'unchecked'; // indeterminate, checked, unchecked
    @ViewChild('cbSelectAllInp') cbSelectAllInp: ElementRef;
    elementType: any;
    cbSelectAllInpChecked: boolean;
    headerCheckBox: boolean;
    clearAllBtn: boolean;
    rowCheckBox: boolean;
    doNotProceed: boolean;

    constructor(private elementRef: ElementRef) { }

    agInit(params: any): void {
        this.elementType = params.type;
        this.headerCheckBox = (this.elementType === 'headerCheckBox');
        this.clearAllBtn = (this.elementType === 'clearAllBtn');
        this.rowCheckBox = (this.elementType === 'rowCheckBox');
        this.params = params;

        if(params.cbSelectAllInpChecked){
            this.cbSelectAllInpChecked = params.cbSelectAllInpChecked;
        }

        this.defalutCheckBoxSettings();
        const justAddEvents = this.elementType === 'justAddEvents';

        if (this.headerCheckBox || justAddEvents) {
            this.params?.api?.addEventListener('modelUpdated', this.selectAllRows.bind(this));
            this.params?.api?.addEventListener('rowClicked', this.rowClickedAction.bind(this));
            this.params?.api?.addEventListener('filterChanged', this.filterChangedAction.bind(this));
        }

        if(typeof this.lastSelectedIndex === "undefined") {
            this.lastSelectedIndex = null;
        }
    }

    filterChangedAction(){
        this.params.parentObject.params?.api.deselectAll();
        this.params.parentObject.grid?.api.deselectAll();
        this.params.parentObject['selectedOrDeSelectedRecords'] = [];
        this.params.parentObject['selectedRowsMap'] = new Map<string,any>();
        this.params.parentObject['isSelectedAll'] = false;
        this.params.parentObject['headerCheckBoxState'] = 'unchecked';
        this.params.parentObject.enableDisableBtns();
    }

    defalutCheckBoxSettings() {
        if (!this.params.parentObject.selectedOrDeSelectedRecords) {
            this.params.parentObject['selectedOrDeSelectedRecords'] = [];
        }
        if (!this.params.parentObject.selectedRowsMap) {
            this.params.parentObject['selectedRowsMap'] = new Map<string,any>();
        }
        if (!this.params.parentObject.isSelectedAll) {
            this.params.parentObject['isSelectedAll'] = false;
        }
        if (!this.params.parentObject.headerCheckBoxState) {
            this.params.parentObject['headerCheckBoxState'] = 'unchecked';
        }
                
        if(this.cbSelectAllInpChecked){            
            this.params.parentObject['isSelectedAll'] = true;
            this.params.parentObject['headerCheckBoxState'] = 'checked';
        }
    }

    cbSelectAll() {
        this.clearRowIds();
        
        if (!this.params.parentObject.isSelectedAll) {
            this.params.parentObject['isSelectedAll'] = true;
            this.params.parentObject.headerCheckBoxState = 'checked';
            this.selectAllRows();
        } else {
            this.params.parentObject['isSelectedAll'] = false;
            this.params.parentObject.headerCheckBoxState = 'unchecked';
            this.deselectAllRows();
            if (this.params.context && this.params.context.componentParent && this.params.context.componentParent.removeDeselectedRecordsIfPresent) {
                this.params.api.deselectAll();
            }
        }
        this.params.parentObject.enableDisableBtns();
    }

    cbSetIndeterminate(params: any) {
        const isRowCheckBoxSelected: boolean = !params.node.isSelected();
        params.node.setSelected(isRowCheckBoxSelected);

        const objectId = this.getValueForUniqueFields(params.data, this.params.parentObject.uniqueField);
        let isSelectedAllChecked = this.params.parentObject['isSelectedAll'];
        let isSelectedRowsPresent: boolean;

        if (isSelectedAllChecked) {
            if (isRowCheckBoxSelected) {
                isSelectedRowsPresent = this.deleteSelectedRowId(objectId);
            } else if (!isRowCheckBoxSelected) {
                isSelectedRowsPresent = this.setSelectedRowId(objectId);
            }
        } else {
            if (!isRowCheckBoxSelected) {
                isSelectedRowsPresent = this.deleteSelectedRowId(objectId);
            } else if (isRowCheckBoxSelected) {
                isSelectedRowsPresent = this.setSelectedRowId(objectId);
            }
        }

        /*
        *  if user select all records one by one then check total records and selected records
        * */
        const totalRecordsFromServer: number = this.params.parentObject.totalRecordsFromServer ? Number(this.params.parentObject.totalRecordsFromServer) : 0;
        const selectedRecords: number = this.params.api.getSelectedRows().length;
        const selectedRecordsStored: number = this.params.parentObject['selectedOrDeSelectedRecords'].length;
        
        if (isSelectedRowsPresent && !(totalRecordsFromServer === selectedRecords) && !(totalRecordsFromServer === selectedRecordsStored)) {
            this.params.parentObject.headerCheckBoxState = (selectedRecords > 0) ? 'indeterminate' : 'unchecked';
        } else {
            if ((totalRecordsFromServer === selectedRecords) || isSelectedAllChecked && selectedRecordsStored === 0) {
                this.params.parentObject['isSelectedAll'] = true;
                isSelectedAllChecked = true;
            } else {
                this.params.parentObject['isSelectedAll'] = false;
                isSelectedAllChecked = false;
            }

            this.params.parentObject['selectedOrDeSelectedRecords'] = [];
            if (selectedRecords === 0)
                this.params.parentObject['selectedRowsMap'] = new Map<string, any>();
            this.params.parentObject.headerCheckBoxState = isSelectedAllChecked ? 'checked' : 'unchecked';
        }
    }

    selectAllRows() {
        const isSelectedAllChecked = this.params.parentObject['isSelectedAll'];
        const uniqueField = this.params.parentObject.uniqueField;
        const currentIds =this.params.parentObject['selectedOrDeSelectedRecords'];
        let notLoaded = false;
        let selectedList: Array<string> = null;
        
        if(!uniqueField) {
            console.error("uniqueField must be defined in parent.");
        }

        this.params.parentObject.params?.api.deselectAll();
        this.params.parentObject.grid?.api.deselectAll();
        
        if (isSelectedAllChecked) {
            if (this.params.selectAllWithFilter) {
                this.params.api.forEachNodeAfterFilter((rowNode: any) => {
                    if(rowNode.data) {
                        this.selectAllRowsSetSelected(rowNode, currentIds);
                    } else {
                        notLoaded = true;
                    }
                });
            } else {
                this.params.api.forEachNode((rowNode: any) => {
                    if(rowNode.data) {
                        this.selectAllRowsSetSelected(rowNode, currentIds);
                    } else {
                        notLoaded = true;
                    }
                });
            }
        } else {
           this.params.api.forEachNode((rowNode: any) => {
                if(rowNode.data) {
                    const rowDataId = this.getValueForUniqueFields(rowNode.data, uniqueField);
                    const index: number = currentIds? currentIds.indexOf(rowDataId): -1;
                    
                    if (!this.isDisabled(rowNode)) {
                        rowNode.setSelected(index !== -1);

                        if(index !== -1) {
                          if (!selectedList) selectedList = [];
                            selectedList.push(rowDataId);
                        }
                    }
                } else {
                    notLoaded = true;
                }
            });
        }

        if(notLoaded) {
            setTimeout(() => { 
                this.selectAllRows(); 
            });
        } else {
            // if (selectedList !== null && selectedList !== undefined) {
            //   this.params.parentObject['selectedOrDeSelectedRecords'] = selectedList;
            // }
            this.params.parentObject.enableDisableBtns();

            if(!isSelectedAllChecked && selectedList && selectedList.length === 0) {
                this.params.parentObject.headerCheckBoxState = "unchecked";
            }
        }
    }

    selectAllRowsSetSelected(rowNode: any, currentIds: any) {
        const uniqueField = this.params.parentObject.uniqueField;
        let isIdPresent = false;
        const rowDataId = this.getValueForUniqueFields(rowNode.data, uniqueField);
        if (currentIds.length) {
            const index: number = currentIds.indexOf(rowDataId);
            if (index === -1) {
                isIdPresent = false;
            } else {
                isIdPresent = true;
            }
        }
        if (!rowNode.isSelected() && !isIdPresent && !this.isDisabled(rowNode) && this.ignoreUserDeselectedRecordsToSelect(rowNode)) {
            rowNode.setSelected(true);
        }
    }

    deselectAllRows() {
        this.params.parentObject['deselectedFromSelectAllRecords'] = [];
        this.params.api.deselectAll();
        // previous implementation - only unselects visible rows
        /*
        this.params.api.forEachNode((rowNode: any) => {
            if (!this.isDisabled(rowNode)) {
                rowNode.setSelected(false);
            }
        });
        */
        this.params.parentObject['selectedOrDeSelectedRecords'] = [];
        this.params.parentObject['selectedRowsMap'] = new Map<string,any>();
        this.params.parentObject['isSelectedAll'] = false;
        this.params.parentObject.headerCheckBoxState = 'unchecked';
    }

    setSelectedRowId(objectId: any) {
        const currentIds = this.params.parentObject['selectedOrDeSelectedRecords'];
        const index: number = currentIds.indexOf(objectId);
        if (index === -1) {
            currentIds.push(objectId);
        }
        return (currentIds.length ? true : false);
    }

    deleteSelectedRowId(objectId: any) {
        const currentIds = this.params.parentObject['selectedOrDeSelectedRecords'];
        const index: number = currentIds.indexOf(objectId);
        if (index !== -1) {
            currentIds.splice(index, 1);
        }
        return (currentIds.length ? true : false);
    }

    clearRowIds() {
        this.params.parentObject['selectedOrDeSelectedRecords'] = [];
        this.params.parentObject['selectedRowsMap'] = new Map<string,any>();
    }

    clearAllFilters() {
        this.params.parentObject.params?.api.deselectAll();
        this.params.parentObject.grid?.api.deselectAll();
        this.params.parentObject.clearAllFilters();
        this.params.parentObject['selectedOrDeSelectedRecords'] = [];
        this.params.parentObject['selectedRowsMap'] = new Map<string,any>();
        this.params.parentObject['isSelectedAll'] = false;
        this.params.parentObject['headerCheckBoxState'] = 'unchecked';
        this.params.parentObject.enableDisableBtns();
    }

    onParentModelChanged() { }

    get lastSelectedIndex()  {
        return IrbCustomHeaderComponent._lastSelectedIndex;
    }

    set lastSelectedIndex(n: number) {
        IrbCustomHeaderComponent._lastSelectedIndex = n;
    } 

    rowSelectedAction(params: any, e: MouseEvent) {
        // this.doNotProceed = true;
        const objectId = this.getValueForUniqueFields(params.data, this.params.parentObject.uniqueField);
        const i = this.params.parentObject['selectedOrDeSelectedRecords'].indexOf(objectId);
        
        if(i === -1) {
            this.params.parentObject['selectedOrDeSelectedRecords'].push(objectId);
        } else {
            this.params.parentObject['selectedOrDeSelectedRecords'].splice(i,1);
        }

        if (this.params.parentObject['selectedRowsMap'].has(objectId)) {
            this.params.parentObject['selectedRowsMap'].delete(objectId);
        } else {
            this.params.parentObject['selectedRowsMap'].set(objectId, params.data);
        }

        //when the shift is down, select records between the selected and last selected indices
        if(e.shiftKey && this.lastSelectedIndex !== null) {
            const currentIds =this.params.parentObject['selectedOrDeSelectedRecords'];
            const selectedList: Array<string> = [];

            this.params.api.forEachNode((rowNode: any) => {
                this.rowSelectedActionIterationItem(rowNode, selectedList, params);
            });

            this.params.parentObject['selectedOrDeSelectedRecords'] = this.params.parentObject['selectedOrDeSelectedRecords'].concat(selectedList);
        }

        const rowIndex = params.node.rowIndex;
        this.lastSelectedIndex = rowIndex;
        this.cbSetIndeterminate(this.params);
        this.params.parentObject.enableDisableBtns();

        if (this.params.parentObject.setSelectedChips) {
            this.params.parentObject.setSelectedChips(params);
        }
    }
    rowSelectedActionIterationItem(rowNode: any, selectedList: any, params: any) {
        if(rowNode.data) {
            if (!this.isDisabled(rowNode)) {
                const a = rowNode.rowIndex > this.lastSelectedIndex && rowNode.rowIndex < params.node.rowIndex;
                const b = rowNode.rowIndex < this.lastSelectedIndex && rowNode.rowIndex > params.node.rowIndex;

                if(a || b) {
                    rowNode.setSelected(true);
                    const rowDataId = this.getValueForUniqueFields(rowNode.data, this.params.parentObject.uniqueField);
                    const index = this.params.parentObject['selectedOrDeSelectedRecords'].indexOf(rowDataId);
                    this.params.parentObject['selectedRowsMap'].set(rowDataId, rowNode.data);
                    if (index === -1) {
                        selectedList.push(rowDataId);
                    }
                }
            }
        }
    }

    isDisabled(rowNode?: any) {
        if (typeof rowNode === "undefined") {
            rowNode = this.params.node;
        }
    
        if (this.params.context && this.params.context.componentParent.isDisabled) {
            let b = this.params.context.componentParent.isDisabled(rowNode.data);
            let checkSelected = this.params.context.componentParent.checkSelected;
            if (b && checkSelected) {
                rowNode.setSelected(true);
            }
            return b;
        }
    
        return false;
    }
    ignoreUserDeselectedRecordsToSelect(rowNode?: any){
        if(this.params.parentObject.ignoreUserDeselectedRecords){
        const deselectedFromSelectAllRecords = this.params.parentObject['deselectedFromSelectAllRecords'];
            if(deselectedFromSelectAllRecords && deselectedFromSelectAllRecords.length){
                // console.log('deselectedFromSelectAllRecords ',deselectedFromSelectAllRecords);
                if(this.params.context && this.params.context.componentParent.isDeselectedRecordsPresent){
                    const checkflag = this.params.context.componentParent.isDeselectedRecordsPresent(rowNode.data);
                    return checkflag;
                }

            }else{
                return true;
            }
        }
        return true;
    }

    rowClickedAction(event: any) {
        let rowData = event.data;
        if (this.params.parentObject.isSelectedAll) {
            if (event.node.isSelected()) {
                const deselectedFromSelectAllRecords = this.params.parentObject['deselectedFromSelectAllRecords'];
                // this is always false because rowData is a different object (especially after re-sort), not part of an array
                let index = deselectedFromSelectAllRecords.indexOf(rowData, 0);
                // code below implements search by unique field if such exists
                if (index === -1) {
                  const uniqueField = this.params.parentObject.uniqueField;
                  if (deselectedFromSelectAllRecords && uniqueField) {
                    const rowDataId = this.getValueForUniqueFields(rowData, uniqueField);
                    if (rowDataId) {
                      for ( let i = 0; i < deselectedFromSelectAllRecords.length; i++) {
                        const record = deselectedFromSelectAllRecords[i];
                        const id = this.getValueForUniqueFields(record, uniqueField);
                        if (id && id === rowDataId ) {
                          index = i;
                          rowData = record;
                          break;
                        }
                      }
                    }
                  }
                }
                if (this.params.context && this.params.context.componentParent && this.params.context.componentParent.removeDeselectedRecordsIfPresent) {
                    index = this.params.context.componentParent.removeDeselectedRecordsIfPresent(rowData);
                }
                if (index > -1) {
                    deselectedFromSelectAllRecords.splice(index, 1);
                }
            } else if (!event.node.isSelected()) {
              if (this.params.parentObject['deselectedFromSelectAllRecords'].indexOf(rowData) === -1) {
                this.params.parentObject['deselectedFromSelectAllRecords'].push(rowData);
              }
            }
        }
    }

    getValueForUniqueFields(data: any, uniqueField: string) {
        let objectId = '';

        if (uniqueField) {
            if (uniqueField.includes(',')){
                const fields = uniqueField.split(',');
                fields.forEach( (field:any, idx:number) => {
                    objectId += (idx === fields.length -1) ? data[field] : data[field] + '-';
                });
            } else {
                objectId = data[uniqueField];
            }
        } else {
            console.error("uniqueField must be defined in parent.");
        }
        return objectId;
    }
}
